import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store, { persistor } from './redux/store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          toastOptions={{
            style: {
              background: '#fff7ed',
              color: '#9a4d00',
              border: '1px solid #fdba74',
              borderRadius: '12px',
              boxShadow: '0 10px 25px rgba(249, 115, 22, 0.15)',
            },
            success: {
              style: {
                background: '#ecfdf5',
                color: '#14532d',
                border: '1px solid #86efac',
              },
            },
            error: {
              style: {
                background: '#fff7ed',
                color: '#9a4d00',
                border: '1px solid #fdba74',
              },
            },
          }}
          progressStyle={{ background: '#f97316' }}
        />
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
